import { DEFAULT_VOTER_PAGE_SIZE, isVoterPageSize, type VoterPageSize } from './voterPresentation';

export type VotersListState = {
  search: string;
  state: string;
  page: number;
  rowsPerPage: VoterPageSize;
};

export const DEFAULT_VOTER_PAGE = 0;

export { DEFAULT_VOTER_PAGE_SIZE, isVoterPageSize };
